import { getPageTheme } from '../Utils/pageThemeProvider';
import { getPageContext } from '~/Features/Configuration/Utils/pageContextProvider';

export const usePageTheme = () => getPageTheme(getPageContext());
